import { ConciliacaoApsRentabilidadeStatus } from '../generated/backend-enums.js';
export { ConciliacaoApsRentabilidadeStatus };
export const ConciliacaoApsRentabilidadeStatusMap = {
    [ConciliacaoApsRentabilidadeStatus.PENDENTE]: 'Pendente',
    [ConciliacaoApsRentabilidadeStatus.RESOLVIDO]: 'Resolvido',
    [ConciliacaoApsRentabilidadeStatus.DESCONTINUADA]: 'Descontinuada',
};
